export const C = {
  darkBrown: '#2C2418', brown: '#5C4A32', lightBrown: '#9B8E7E',
  darkGreen: '#454803', green: '#5D6102', lightGreen: '#BABE83',
  mustard: '#CF9F19', yellow: '#E8B820', lightBeige: '#F6EDD2',
  white: '#FAFAF5', pureWhite: '#FFFFFF',
  concern: '#A0522D', concernBg: '#FDF5EF',
  optimal: '#5D6102', optimalBg: '#F4F5E8',
  warning: '#CF9F19', warningBg: '#FBF5E0',
  borderline: '#CF9F19', borderlineBg: '#FBF5E0',
  red: '#B33A2A', redBg: '#FDEEEB',
};

export const F = {
  h: "'Ivar Display', 'Playfair Display', 'Georgia', serif",
  b: "'DM Sans', -apple-system, sans-serif",
};
